import React from "react";
import { motion } from "framer-motion";
import "./QualityCertificate.css";

/* ASSETS */
import cert1 from "../assets/ce1.jpg";
import cert2 from "../assets/ce2.jpg";
import finalBanner from "../assets/finalbanner.png";

const QualityCertificate = () => {
  return (
    <div className="qc-page">
      {/* ===== SERVICES STYLE HERO ===== */}
    <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
  QUALITY & CERTIFICATE
</motion.h1>

  </div>
</section>

      {/* ===== QUALITY POLICY ===== */}
      <section className="qc-quality">
        <div className="qc-container">
          <div className="qc-text">
            <h2>Our Standards</h2>
            <div className="qc-badge-row">
              {/* <span className="iso-badge">ISO 9001:2015 CERTIFIED</span> */}
            </div>

            <p>
            We are strictly adhere towards our quality system and certified by ISO 9001: 2015. The Quality assurance system will follow approved Quality plan while manufacturing the product. All instrumentation and measuring instruments are calibrated time to time. The facilities available are at its best for the range of the product.
            </p>
<br/>
            <p>
              The company has a belief is excellence and is dedicated to proving outstanding quality in its range of products and services. We endeavor to be responsive to the needs of our clients and to encourage innovation in new ideas and improve products, embracing the latest technology in our design and production facilities.
            </p>
          </div>

          <div className="qc-highlight">
            <div className="qc-box">
              <h3>Standardization</h3>
              <span>ISO 9001 : 2015</span>
            </div>
            <div className="qc-box">
              <h3>Infrastructure</h3>
              <span>Calibrated Labs</span>
            </div>
            <div className="qc-box">
              <h3>Reliability</h3>
              <span>Industry Verified</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CERTIFICATES ===== */}
      <section className="qc-certificate">
        <div className="qc-cert-grid">
          <motion.div whileHover={{ y: -12 }} className="qc-cert-card">
            <img src={cert1} alt="ISO Certificate" />
            <h4>QUALITY MANAGEMENT</h4>
          </motion.div>

          <motion.div whileHover={{ y: -12 }} className="qc-cert-card">
            <img src={cert2} alt="Naval Certificate" />
            <h4>NAVAL COMPLIANCE</h4>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default QualityCertificate;
